import { AskAIComponent } from '@ispm/dashboard/ask-ai/components/ask-a-i.component';
import { AskAIService } from '@ispm/dashboard/ask-ai/services/ask-a-i.service';

export const ASK_AI_SERVICES = [AskAIService];
export const ASK_AI_COMPONENTS = [AskAIComponent];
export const ASK_AI_COMPONENTS_EXPORTS = [AskAIComponent];
